import styles from './Receipt.module.scss';

import { Fullscreen } from '@mui/icons-material';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ChangeEvent, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { usePreviewNavigation } from '@work4all/components/lib/components/entity-preview/erp-preview/usePreviewNavigation';
import { IconButtonWithTooltip } from '@work4all/components/lib/input/actions/IconButtonWithTooltip';
import { Remove } from '@work4all/components/lib/input/actions/remove/Remove';
import { Upload } from '@work4all/components/lib/input/actions/upload/Upload';
import {
  FilePreview,
  FilePreviewProvider,
  useFilePreview,
} from '@work4all/components/lib/preview/FilePreviewProvider';

import { TempFileManagerContext } from '@work4all/data/lib/hooks/data-provider/useTempFileManager';

import { Collapse } from '../../../../../../../components';

export function Receipt() {
  const receiptConext = useContext(TempFileManagerContext);
  const { file, component } = usePreviewNavigation(receiptConext.fileList);

  return (
    <FilePreviewProvider file={file}>
      <ReceiptInternal navigation={component} />
    </FilePreviewProvider>
  );
}

function ReceiptInternal({ navigation }: { navigation: JSX.Element }) {
  const { t } = useTranslation();

  const { openFullscreen, file } = useFilePreview();
  const receiptConext = useContext(TempFileManagerContext);

  const onUpload = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      receiptConext.uploadFiles(Array.from(e.target.files));
    },
    [receiptConext]
  );

  const onRemove = useCallback(() => {
    const id = file?.id;
    receiptConext.markFilesToDelete([id?.toString()]);
  }, [receiptConext, file]);

  const headerBar = (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Upload onChange={onUpload} noTitle />
        {file && <Remove onClick={onRemove} />}
        {file && (
          <IconButtonWithTooltip
            tooltip={t('COMMON.FULLSCREEN')}
            icon={<Fullscreen />}
            onClick={openFullscreen}
          />
        )}
      </Stack>
      {navigation}
    </Stack>
  );

  return (
    <Collapse
      className={styles.receipt}
      title={t('MASK.RECEIPT')}
      defaultOpen
      headerBar={headerBar}
    >
      <Box
        bgcolor={'#eeeeee'}
        height={'100%'}
        minHeight={600}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {file ? (
          <FilePreview file={file} />
        ) : (
          <Typography>{t('COMMON.EMPTY')}</Typography>
        )}
      </Box>
    </Collapse>
  );
}
